const ITEMS = [
  "Ménage de logements",
  "Entretien de locaux",
  "Nettoyage automobile",
  "Fin de chantier",
  "Espaces soignés",
  "Devis gratuit sous 24h",
  "Gap et alentours",
  "Produits éco-responsables",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-white/10 bg-[#0D1220] py-6 overflow-hidden">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-display text-2xl sm:text-3xl font-bold uppercase tracking-tight text-stroke">
                  {item}
                </span>
                <span className="text-amber-400 text-lg">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
